export const getColumnWidth = (field: string): string => {
  switch (field) {
    case 'type':
      return 'w-8';
    case 'name':
      return 'w-1/4';
    case 'status':
      return 'w-32';
    case 'created':
      return 'w-40';
    default:
      return '';
  }
};
